/*
 * LocationPropertyRoute.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Sat Feb 25 2023 mys Company
 */

import { Route } from 'react-router-dom'
import LocationPropertyPage from '../pages/LocationPropertyPage'
import LocationPropertysPage from '../pages/LocationPropertysPage'

const LocationPropertyRoute = (
    <Route path="locationProperty">
        <Route index element={<LocationPropertysPage />} />
        <Route path=":id" element={<LocationPropertyPage />} />
    </Route>
)

export default LocationPropertyRoute
